export const DEPARTMENTS = [
  'Sales',
  'Client Services',
  'Operations',
  'Technology',
  'Finance',
  'CEO Office',
  'HR',
  'Marketing'
]